import React, { useEffect } from "react";
import { useLoginFlow } from "@jugl-web/utils";
import { useSelector } from "react-redux";
import { selectAuthState } from "@web-src/modules/auth/store/authSlice";
import { NavigateToDefaultEntity } from "@web-src/modules/navigation/components/NavigateToDefaultEntity/NavigateToDefaultEntity";
import { useStartSessionRecording } from "@web-src/modules/common/utils/posthogSetup";
import { CXOnboardingFlow } from "../../components/CXOnboardingFlow";

const CXLoginPageContent: React.FC = () => {
  useStartSessionRecording();

  const { setLoginFlow } = useLoginFlow();

  useEffect(() => {
    setLoginFlow("cx");
  }, [setLoginFlow]);

  return <CXOnboardingFlow initialStep="credentials" showCarousel />;
};

export const CXLoginPage: React.FC = () => {
  const { isAuthenticated } = useSelector(selectAuthState);

  if (isAuthenticated) {
    return <NavigateToDefaultEntity />;
  }

  return <CXLoginPageContent />;
};
